//@flow
/**
 *
 * @param  {...any} args
 * @returns {string}
 *
 * @example
 * className('foo', 'bar', false, undefined, 0, 1, {baz: true}, 'qux');
 * // => 'foo bar 1 baz qux'
 */
export function classNames(...args: any[]): string {
  const classes = [];

  for (const arg of args) {
    if (typeof arg === 'string' || typeof arg === 'number') {
      classes.push(arg);
      continue;
    }

    if (typeof arg === 'object') {
      for (const key in arg) {
        if (arg[key]) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(' ');
}
